import DBModal from "../../../../component/global/DBModal";
import BackButton from "../../../../component/global/BackButton";
import logo from './../../../../asset/image/logo_1.svg'
import {useTranslation} from "react-i18next";
import DBButton from "../../../../component/global/DBButton";
import {useEffect, useMemo, useRef, useState} from "react";
import {numberWithCommas} from "../../../../utils/methods";
import {get, post} from "../../../../controlers/global/ConfigRequest";
import {BUY_PACKAGE, COMPANY_DETAIL, VALIDATE_DISCOUNT} from "../../../../helperData/ApiAddress";
import moment from "moment-jalaali";

const tax = 9

const initialDiscount = {
  id: 0,
  value: 0
}

function PackagesPaymentModal(props) {
  const {status, onHide, show, data, onSuccess} = props
  const [discount, setDiscount] = useState(initialDiscount)
  const [company, setCompany] = useState({})
  const [loading, setLoading] = useState(false)
  const [paymentError, setPaymentError] = useState('')
  const {t} = useTranslation();
  const inputRef = useRef()
  const statusClassName = status ? 'success' : 'failed'
  // const statusTitle = status ? t('Organizational.Profile.Packages.Payment.Status.Success') : t('Organizational.Profile.Packages.Payment.Status.Failed')
  const statusTitle = t('Organizational.Profile.Packages.Payment.Status.Unpaid')
  // console.log('data', data)

  useEffect(() => {
    if (show) {
      if (sessionStorage.getItem('usertype') === '2' && sessionStorage.getItem('usercompany')) {
        get(COMPANY_DETAIL.replace("{id}", sessionStorage.getItem('usercompany')))
          .then(res => {
              // console.log('PackagesPaymentModal res', res)
              setCompany(res)
            }
          )
      }
    }
  }, [show])

  const month = useMemo(() => {
    return (data?.price?.duration_as_days / 30) || 0
  }, [data?.price?.duration_as_days])

  const finalDiscount = useMemo(() => {
    if (data?.price?.price) {
      const initialDiscount = data?.price?.discount || 0
      const price = data?.price?.price || 0
      const tmpDiscount = discount?.value || 0
      const percent = (tmpDiscount + initialDiscount) / 100
      return price * percent
    }
    return 0
  }, [data?.price?.price, data?.price?.discount, discount?.value])

  const totalAmount = useMemo(() => {
    if (data?.price?.price) {
      const finalPrice = data?.price?.price - finalDiscount
      return finalPrice + (finalPrice * (tax / 100))
    }
    return 0
  }, [data?.price?.price, finalDiscount])

  const receiptDate = useMemo(() => {
    const start = moment().format('jYYYY/jMM/jDD')
    let end = ''
    if (data?.price?.duration_as_days) {
      end = moment().add(data?.price?.duration_as_days, 'd').format('jYYYY/jMM/jDD')
    }
    return `${start} الی ${end}`
  }, [data?.price?.duration_as_days])

  function onClose() {
    setDiscount(initialDiscount)
    inputRef.current.value = ''
    setLoading(false)
    setCompany({})
    setPaymentError('')
    onHide?.()
  }

  return (
    <DBModal
      minWidth={300}
      show={show}
      onHide={onClose}
      className="packages-payment-modal"
    >
      <DBModal.Content>
        <div className='header-modal'>
          <BackButton onclickFunction={onClose}/>
        </div>
        <div className="content-modal">
          <div className="payment-detail">
            <div className="status-modal">
              <div className={`title ${statusClassName}`}>
                {statusTitle}
              </div>
            </div>
            <div className="detail-box">
              <div className='title'>
                {t('Organizational.Profile.Packages.Payment.Status.Title')}
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Type')}: <span>{data?.name}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Time')}: <span>{month} {t('Organizational.Profile.Packages.Payment.Time')}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Price')}: <span>{numberWithCommas(`${data?.price?.price || 0}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
              </div>
              <div className='detail discount'>
                <div>
                  {t('Organizational.Profile.Packages.Payment.Status.Discount')}: <span>{numberWithCommas(`${finalDiscount || 0}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
                </div>
                <div className='enter-discount'>
                  <input ref={inputRef} id='discount' name='discount'/>
                  <DBButton
                    caption={t('Organizational.Profile.Packages.Payment.Status.Discount.ButtonLabel')}
                    loading={loading}
                    onClick={() => {
                      const value = inputRef.current.value
                      // console.log('value', value)
                      setLoading(true)
                      setPaymentError('')
                      get(VALIDATE_DISCOUNT + value)
                        .then(res => {
                          console.log('res', res)
                          setDiscount(res)
                        })
                        .catch(err => {
                          const text = err?.response?.data?.detail
                          setPaymentError(text)
                        })
                        .finally(() => {
                          setLoading(false)
                        })
                    }}
                  />
                </div>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.AddedValue')}: <span>%{tax}</span>
              </div>
              <div className='divider'></div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Total')}: <span>{numberWithCommas(`${totalAmount || 0}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
              </div>
            </div>
          </div>
          <div className="company-detail">
            <div className='logo'>
              <img src={logo} alt="logo"/>
            </div>
            <div className="company-box">
              <div className='title'>
                {t('Organizational.Profile.Packages.Payment.Company.Status.Title')}
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Company.Title')}: <span>{company?.name}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Company.Address')}: <span>{company?.address}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Company.PhoneNumber')}: <span>{company?.phone_number}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Company.Receipt.Count')}: <span>-</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Company.Receipt.Period')}: <span>{receiptDate}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='error-modal'>
          {paymentError}
        </div>
        <div className='btn-modal'>
          <DBButton
            caption={t('Organizational.Profile.Packages.Payment.Button.cancel.Label')}
            className='btn-close'
            onClick={onClose}
          />
          <DBButton
            caption={t('Organizational.Profile.Packages.Payment.Button.Accept.Label')}
            className='payment'
            loading={loading}
            onClick={() => {
              setLoading(true)
              setPaymentError('')
              const body = {
                package_price: data.price.id,
              }
              if (discount.id) {
                body.discount = discount.id
              }
              post(BUY_PACKAGE, body).then(res => {
                console.log('BUY_PACKAGE res', res)
                onClose()
                onSuccess(res)
              }).catch(err => {
                const text = err?.response?.data?.detail
                setPaymentError(text)
              }).finally(() => {
                setLoading(false)
              })
            }}/>
        </div>
      </DBModal.Content>
    </DBModal>
  );
}

export default PackagesPaymentModal;
